<template>
  <div>
    <section class="section">
      <div class="container">
        <h1 class="title">Änderungen der letzten 30 Tage</h1>
        <i v-if="timestamp">Generiert: {{ timestamp }}</i>
        <loader :active="isLoading"></loader>
        <br>
        <br>
        <template v-for="(change,index) in changes">
          <div :key="index">{{ change }}</div>
        </template>
        <br>
        <h1 class="title">Alben Index</h1>
        <nav class="panel">
          <div class="panel-heading">
            <div class="field has-addons">
              <div class="control is-expanded has-icons-left">
                <input v-model="filter"
                       @keyup.enter="search"
                       class="input"
                       type="text"
                       placeholder="Suchen...">
                <span class="icon is-left">
                  <font-awesome-icon icon="search"></font-awesome-icon>
                </span>
              </div>
              <div class="control">
                <div @click="search"
                     class="button is-info">Suchen</div>
              </div>
            </div>
          </div>
          <template v-for="(folder,key) in index">
            <folder v-show="folder.show"
                    :key="key"
                    :folder="folder"
                    :forceExpanded="forceExpanded"></folder>
          </template>
        </nav>
      </div>
    </section>
  </div>
</template>

<script>
import Folder from '@/components/Folder';
import Loader from '@/components/Loader';
import axios from 'axios';
// import moment from 'moment';

export default {
  name: 'AlbumList',
  components: {
    Folder,
    Loader
  },
  data () {
    return {
      timestamp: null,
      changes: [],
      index: [],
      filter: '',
      forceExpanded: false,
      isLoading: false
    };
  },
  watch: {
    filter (searchString) {
      if (searchString === '') {
        this.showAll();
      };
    }
  },
  methods: {
    load () {
      this.isLoading = true;
      axios
        .get('./index.json')
        .then(res => {
          const options = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          };
          this.timestamp = new Date(res.data.timestamp * 1000).toLocaleString('de-DE', options);
          this.changes = res.data.changes;
          this.index = res.data.index[0].contents;
          this.showAll();
          this.isLoading = false;
        });
    },
    search () {
      if (this.filter !== '') {
        this.index = this.index.map(folder => {
          folder.contents = folder.contents.map(band => {
            band.contents = band.contents.map(album => {
              album.show = band.name.toLowerCase().includes(this.filter.toLowerCase()) || album.name.toLowerCase().includes(this.filter.toLowerCase());
              return album;
            });
            band.show = band.name.toLowerCase().includes(this.filter.toLowerCase()) || band.contents.some(album => album.show);
            return band;
          });
          folder.show = folder.contents.some(band => band.show);
          return folder;
        });
        this.forceExpanded = true;
      }
    },
    showAll () {
      this.index = this.index.map(folder => {
        folder.contents = folder.contents.map(band => {
          band.contents = band.contents.map(album => {
            album.show = true;
            return album;
          });
          band.show = true;
          return band;
        });
        folder.show = true;
        return folder;
      });
      this.forceExpanded = false;
    }
  },
  mounted () {
    this.load();
  }
};
</script>
